import { useDispatch } from 'react-redux';
import {
    showErrorToast as showErrorToastAction,
    showSuccessToast as showSuccessToastAction,
    showWarningToast as showWarningToastAction,
} from './toasts.state';
import { ToastOpts } from './toasts.types';

interface UseToasts {
    showErrorToast:(params:ToastOpts) => void;
    showSuccessToast:(params:ToastOpts) => void;
    showWarningToast:(params:ToastOpts) => void;
}

export const useToasts = (): UseToasts => {
    const dispatch = useDispatch();

    const showErrorToast = (toastoptions : ToastOpts) => {
        dispatch(showErrorToastAction(toastoptions));
    };

    const showSuccessToast = (toastoptions : ToastOpts) => {
        dispatch(showSuccessToastAction(toastoptions));
    };

    const showWarningToast = (toastoptions : ToastOpts) => {
        dispatch(showWarningToastAction(toastoptions));
    };

    return {
        showErrorToast,
        showSuccessToast,
        showWarningToast,
    };
};
